import { useCallback } from 'react';
import { useMyCapabilities } from './metadata/capabilities';
import { canEditDealField } from './fieldEditRules';

/** The current user's per-field edit access for grids (REG-739); rules in fieldEditRules.ts. */
export function useFieldEditAccess() {
  const { hasCapability, isLoading } = useMyCapabilities();
  const canEditField = useCallback(
    (tableName: string, fieldName: string) => !isLoading && canEditDealField(tableName, fieldName, hasCapability),
    [hasCapability, isLoading],
  );
  return { canEditField, isLoading };
}
